/**
 * Created by User on 18/02/2016.
 * @name AdConsts
 */
export default {
  //ad types
  AFTER_PAUSE_ROLL: 'afterpauseroll',
  OVERLAY: 'overlay',
  PAUSE_ROLL: 'pauseroll',
  POSTROLL: 'postroll',
  PREROLL: 'preroll',
  MIDROLL: 'midroll',
  START_SCREEN: 'startscreen',

  //ad time units
  PERCENT: 'PERCENT',
  SECONDS: 'SECONDS',

  //Miscellaneous constants
  GOOGLE_IN_VAST: 'googleInVast',
  ALLOW_BLOCK: 'Allowblock',

  //Play states
  STATE_PLAY: 'PLAY',
  STATE_PAUSE: 'PAUSE',
  STATE_RESUME: 'RESUME',
  STATE_COMPLETE: 'COMPLETE',

  //block's events
  BLOCK_STARTED: 'ad:block:started',
  BLOCK_STARTING_NEW_ELEMENT: 'ad:block:startingNewElement',
  BLOCK_ENDED: 'ad:block:ended',

  //element's events
  MEMBER_READY_TO_SHOW: 'ad:blockMember:readyToShow',
  MEMBER_ERROR: 'ad:blockMember:error',
  MEMBER_COMPLETE: 'ad:blockMember:complete',

  //playlist's events
  PLAYLIST_READY: 'ad:playlist:ready',
  PLAYLIST_ERROR: 'ad:playlist:error',
  PLAYLIST_INFO: 'ad:playlist:info',

  //model's events
  MODEL_READY: 'ad:model:ready',
  MODEL_PLAYLIST_IS_EMPTY: 'ad:model:playlistError',
  MODEL_PLAYLIST_LOADING_ERROR: 'ad:model:playlistLoadingError',
  MODEL_PLAYLIST_PARSING_ERROR: 'ad:model:playlistParsingError',

  //element's events
  ELEMENT_CREATING_SUCCESS: 'ad:element:creatingSuccess',
  ELEMENT_CREATING_FAIL: 'ad:element:creatingFail',
  ELEMENT_NEED_SKIP: 'ad:element:needSkip',

  //vendor's events
  VENDOR_STATE_CHANGE: 'ad:vendor:stateChange',
  VENDOR_MEDIA_ERROR: 'ad:vendor:mediaError',
  VENDOR_ERROR: 'ad:vendor:error',
  VENDOR_EVENT_PROPERTY_POSITION: 'property:ad:vendor:position',

  //player's events
  PLAYER_EVENT_PROPERTY_VIDEO_INFO: 'property:videoInfo',
  PLAYER_EVENT_PROPERTY_POSITION: 'property:position',
  PLAYER_EVENT_STATE_CHANGE: 'player:stateChange',
  PLAYER_EVENT_STOP: 'player:stop',
  PLAYER_EVENT_MEDIA_BEFORE_COMPLETE: 'player:mediaBeforeComplete',

  //player's states (and vendors too)
  PLAYER_STATE_ENDED: 0,
  PLAYER_STATE_PLAYING: 1,
  PLAYER_STATE_PAUSED: 2,
  PLAYER_STATE_BUFFERING: 3,

  //Global ad plugin events
  AD_PLAYLIST_LOADING_COMPLETE: 'ad:external:playlistLoadingComplete',
  AD_PLAYLIST_LOADING_ERROR: 'ad:external:playlistLoadingError',
  AD_MEMBER_STARTED_PLAYING: 'ad:external:memberStartedPlaying',
  AD_NOBANNER: 'ad:external:nobanner',
  AD_XML_LOADING_TIMEOUT: 'ad:external:xmlLoadingTimeout',
  AD_MEDIA_LOADING_TIMEOUT: 'ad:external:mediaLoadingTimeout',
  AD_DUPLICATE_MEDIA: 'ad:external:duplicateMedia',
  AD_VAST_DATA: 'ad:external:vastData',
  AD_BLOCK_STARTED: 'ad:external:blockStarted',
  AD_MEMBER_STARTED_LOADING_NEW_URL: 'ad:external:startedLoadingNewURL',
  AD_XML_LOADING_TIME: 'ad:external:xmlLoadingTime',
  AD_CLOSING_ON_RUNNING_AD: 'ad:external:closingOnRunningAd',
  AD_VAST_EVENT: 'ad:external:vastEvent',
  AD_VAST_XML_INVALID: 'ad:external:vastXMLInvalid',
  AD_MEDIA_BEGINS_LOADING: 'ad:external:mediaBeginsLoading',
  AD_COMPLETE: 'ad:external:adComplete',
  AD_XML_LOADING_ERROR: 'ad:external:xmlLoadingError',
  AD_MEDIAFILE_VENDOR_ERROR: 'ad:external:mediaFileVendorError',
  AD_CANNOT_DISPLAY_MEDIAFILE: 'ad:external:cannotDisplayMediafile',
  AD_WILL_START_IN: 'ad:external:adWillStartIn',
  AD_GOOGLE_IN_VAST: 'ad:external:googleInVast',
  AD_MEMBER_IS_STARTING: 'ad:external:memberIsStarting',

  //Input external common events
  AD_SHOW_ANOTHER_AD: 'ad:showAnotherAd',
  AD_IMHO_DETECTED: 'ad:imhoDetected',

  //External events for ad
  AD_SKIN_VOLUME_CHANGED: 'ad:skin:volumeChanged',
  AD_SKIN_MUTE_CHANGED: 'ad:skin:muteChanged',
  AD_SKIN_RESUME: 'ad:skin:resume',
  AD_SKIN_PAUSE: 'ad:skin:pause',
  AD_SKIN_CLICK_ON_BG: 'ad:skin:clickOnBg',
  AD_SKIN_CLICK_ON_MESSAGE: 'ad:skin:clickOnMessage',
  AD_SKIN_SKIP_BUTTON: 'ad:skin:skipButton',
  AD_SKIN_SKIP_MESSAGE: 'ad:skin:skipMessage',

  //this event plugin expects, when need to show postroll with videoState = COMPLETE on smartTVs
  AD_PLAYER_ENDED: 'ad:playerEnded',

  //Other internal events
  MEDIAFILE_TIMEOUT: 'ad:internal:mediafileTimeout',
  MEDIAFILE_VENDOR_ERROR: 'ad:internal:mediaFileVendorError',
  NOBANNER: 'ad:internal:nobanner',
  XML_TIMEOUT: 'ad:internal:xmlTimeout',
  XML_LOADED: 'ad:internal:xmlLoaded',
  XML_LOADING_ERROR: 'ad:internal:xmlLoadingError',
  XML_PARSING_ERROR: 'ad:internal:xmlParsingError',
  BLOCK_STARTED_DE_FACTO: 'ad:internal:blockStarted',
  MEMBER_STARTED_DE_FACTO: 'ad:internal:memberStarted',
  MEMBER_BEGIN_LOADING: 'ad:internal:memberBeginLoading',
  DUPLICATE_MEDIAFILE: 'ad:internal:duplicateMediaFile',
  PAGE_CLOSING: 'ad:internal:pageClosing',
  VAST_EVENT: 'ad:internal:vastEvent',
  XML_INVALID: 'ad:internal:xmlInvalid',
  MEDIA_BEGINS_LOADING: 'ad:internal:mediaBeginsLoading',
  CANNOT_FIND_VENDOR: 'ad:internal:cannotFindVendor',

	MEDIA_ADT_BEGINS_LOADING: 'ad:internal:mediaAdtBeginsLoading',

  //different constants
  DEVICE_TYPE: 'web',
  PROTOCOL: 'http:',
  APP_VERSION: '',
  MNS_ADLIST: 'mns:adlist',
  SKIP_AD: 'ad:skipAd',
	ADTELLIGENT_HOST: 'hlsp.vcdn.biz',

  // properties
  PROP_GLOBAL_TIMEOUTS: 'ad:globalTimeouts'
};
